export const filterId = 'cron';

export const factory = [
    'aqc.cronService', (cronService) => {
        function format(value: string) {
            let result = '';
            if (value !== null && value !== undefined) {
                const formatted = cronService.fromCron(value);
                const base = formatted.base;
                switch (base) {
                    case 1:
                        result = 'Every minute';
                        break;
                    case 2:
                        result = 'Hourly';
                        break;
                    case 3:
                        result = 'Daily';
                        break;
                    case 4:
                        result = 'Weekly';
                        break;
                    case 5:
                        result = 'Monthly';
                        break;
                    case 6:
                        result = 'Yearly';
                        break;
                    default:
                        break;
                }
            }
            return result;
        }

        return format;
    }
];